'use strict'

module.exports = {
    id: 'add_preset_popups_Contact_4',
    structure: {
        type: 'Page',
        id: 'ntgdn',
        componentTypeForBI: 'wysiwyg.viewer.components.PopupContainer',
        components: [
            {
                type: 'Container',
                id: 'comp-im24czk2',
                components: [
                    {
                        type: 'Component',
                        id: 'comp-im24czkb',
                        skin: 'wysiwyg.viewer.skins.WRichTextNewSkin',
                        layout: {
                            width: 580,
                            height: 48,
                            x: 277,
                            y: 94,
                            scale: 1,
                            rotationInDegrees: 0,
                            fixedPosition: false
                        },
                        componentType: 'wysiwyg.viewer.components.WRichText',
                        data: {
                            type: 'StyledText',
                            metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                            text: '<h2 class="font_2" style="font-size:32px; text-align:center"><span style="color:#4CD1A0;"><span style="font-size:32px"><span style="letter-spacing:0.05em"><span style="font-family:lulo-clean-w01-one-bold,sans-serif">GET IN TOUCH</span></span></span></span></h2>\n',
                            stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
                            linkList: [],
                            id: 'dataItem-im24czkc'
                        },
                        props: {
                            type: 'WRichTextProperties',
                            metaData: {schemaVersion: '1.0'},
                            brightness: 1,
                            packed: true,
                            id: 'propItem-ipf5jr0g'
                        },
                        style: 'txtNew'
                    },
                    {
                        type: 'Component',
                        id: 'comp-im24czkd',
                        skin: 'wysiwyg.viewer.skins.LinkBarNoBGSkin',
                        layout: {
                            width: 102,
                            height: 30,
                            x: 516,
                            y: 354,
                            scale: 1,
                            rotationInDegrees: 0,
                            fixedPosition: false
                        },
                        componentType: 'wysiwyg.viewer.components.LinkBar',
                        data: {
                            type: 'ImageList',
                            metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                            items: [
                                {
                                    type: 'Image',
                                    metaData: {isPreset: false, schemaVersion: '2.0', isHidden: false},
                                    title: 'Black Facebook Icon',
                                    uri: '0fdef751204647a3bbd7eaa2827ed4f9.png',
                                    width: 200,
                                    height: 200,
                                    alt: '',
                                    link: {
                                        type: 'ExternalLink',
                                        metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                                        url: 'https://www.facebook.com/wix',
                                        target: '_blank'
                                    }
                                },
                                {
                                    type: 'Image',
                                    metaData: {isPreset: false, schemaVersion: '2.0', isHidden: false},
                                    title: 'Black Twitter Icon',
                                    uri: 'c7d035ba85f6486680c2facedecdcf4d.png',
                                    width: 200,
                                    height: 200,
                                    alt: '',
                                    link: {
                                        type: 'ExternalLink',
                                        metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                                        url: 'https://twitter.com/wix',
                                        target: '_blank'
                                    }
                                },
                                {
                                    type: 'Image',
                                    metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                                    title: 'Black Instagram Icon',
                                    uri: '01c3aff52f2a4dffa526d7a9843d46ea.png',
                                    width: 200,
                                    height: 200,
                                    alt: '',
                                    link: {
                                        type: 'ExternalLink',
                                        metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                                        url: 'https://www.instagram.com/wix/',
                                        target: '_blank'
                                    }
                                }
                            ],
                            id: 'dataItem-im24czkl'
                        },
                        props: {
                            type: 'LinkBarProperties',
                            metaData: {schemaVersion: '1.0'},
                            gallery: 'social_icons',
                            iconSize: 30,
                            spacing: 6,
                            bgScale: 1,
                            orientation: 'HORIZ',
                            id: 'propItem-im24czko'
                        },
                        style: 'lb1'
                    },
                    {
                        type: 'Component',
                        id: 'comp-im24czl0',
                        layout: {
                            width: 580,
                            height: 18,
                            x: 277,
                            y: 407,
                            scale: 1,
                            rotationInDegrees: 0,
                            fixedPosition: false
                        },
                        componentType: 'wysiwyg.viewer.components.WRichText',
                        data: {
                            type: 'StyledText',
                            metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                            text: '<p class="font_8" style="font-size:14px; text-align:center"><span style="color:#000000;"><span style="font-size:14px"><span style="font-family:avenir-lt-w01_35-light1475496,sans-serif">info@mysite.com &nbsp;| &nbsp;Tel: 123-456-7890 &nbsp;| &nbsp;Fax: 123-456-7890</span></span></span></p>\n',
                            stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
                            linkList: [],
                            id: 'dataItem-im24czl01'
                        },
                        props: {
                            type: 'WRichTextProperties',
                            metaData: {schemaVersion: '1.0'},
                            brightness: 1,
                            packed: true,
                            id: 'propItem-im24czl1'
                        },
                        style: 'txtNew'
                    },
                    {
                        type: 'Container',
                        id: 'comp-im24mixl',
                        components: [
                            {
                                type: 'Component',
                                id: 'comp-im24v0iy',
                                layout: {
                                    width: 276,
                                    height: 30,
                                    x: 0,
                                    y: 407,
                                    scale: 1,
                                    rotationInDegrees: 0,
                                    fixedPosition: false
                                },
                                componentType: 'wysiwyg.viewer.components.WRichText',
                                data: {
                                    type: 'StyledText',
                                    metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                                    text: '<p class="font_8" style="font-size:12px; line-height:1.2em; text-align:center"><span style="color:#CCCCCC;"><span style="font-size:12px"><span style="letter-spacing:0.05em"><span style="font-family:avenir-lt-w01_35-light1475496,sans-serif">500 Terry Francois Street </span></span></span></span></p>\n\n<p class="font_8" style="font-size:12px; line-height:1.2em; text-align:center"><span style="color:#CCCCCC;"><span style="font-size:12px"><span style="letter-spacing:0.05em"><span style="font-family:avenir-lt-w01_35-light1475496,sans-serif">San Francisco, CA 94158</span></span></span></span></p>\n',
                                    stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
                                    linkList: [],
                                    id: 'dataItem-im24v0j3'
                                },
                                props: {
                                    type: 'WRichTextProperties',
                                    metaData: {schemaVersion: '1.0'},
                                    brightness: 1,
                                    packed: true,
                                    id: 'propItem-im24v0j4'
                                },
                                style: 'txtNew'
                            },
                            {
                                type: 'Component',
                                id: 'comp-im24lupg',
                                layout: {
                                    width: 118,
                                    height: 333,
                                    x: 79,
                                    y: 41,
                                    scale: 1,
                                    rotationInDegrees: 0,
                                    fixedPosition: false
                                },
                                componentType: 'wysiwyg.viewer.components.WPhoto',
                                data: {
                                    type: 'Image',
                                    metaData: {isPreset: false, schemaVersion: '2.0', isHidden: false},
                                    title: 'Skateboard with Black Background',
                                    uri: '685c1c71225b4a09be580e1c7fe6e5fc.jpg',
                                    description: '',
                                    width: 679,
                                    height: 1920,
                                    alt: '',
                                    crop: {x: 0, y: 0, width: 679, height: 1885},
                                    id: 'dataItem-im24lupl'
                                },
                                props: {
                                    type: 'WPhotoProperties',
                                    metaData: {schemaVersion: '1.0'},
                                    displayMode: 'fill',
                                    onClickBehavior: 'goToLink',
                                    effectName: 'none',
                                    id: 'propItem-im24lupm'
                                },
                                style: 'wp2'
                            }
                        ],
                        skin: 'wysiwyg.viewer.skins.area.RectangleArea',
                        layout: {
                            width: 277,
                            height: 480,
                            x: 0,
                            y: 0,
                            scale: 1,
                            rotationInDegrees: 0,
                            fixedPosition: false
                        },
                        componentType: 'mobile.core.components.Container',
                        style: {
                            type: 'TopLevelStyle',
                            metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                            style: {
                                groups: {},
                                properties: {'alpha-bg': '1', bg: '#000000'},
                                propertiesSource: {bg: 'value'}
                            },
                            componentClassName: 'mobile.core.components.Container',
                            pageId: '',
                            compId: '',
                            styleType: 'custom',
                            skin: 'wysiwyg.viewer.skins.area.RectangleArea',
                            id: 'style-im24mm5j'
                        }
                    },
                    {
                        'type': 'Component',
                        'skin': 'svgshape.v2.Svg_001419cc721a440abc4ab12ed150b744',
                        'layout': {
                            'width': 30,
                            'height': 30,
                            'x': 811,
                            'y': 16,
                            'scale': 1,
                            'rotationInDegrees': 0,
                            'fixedPosition': false
                        },
                        'componentType': 'wysiwyg.viewer.components.PopupCloseIconButton',
                        'parent': 'comp-im24czk2',
                        'metaData': {
                            'pageId': 'ntgdn'
                        },
                        'data': {
                            'type': 'SvgShape',
                            'metaData': {
                                'isPreset': false,
                                'schemaVersion': '1.0',
                                'isHidden': false,
                                'pageId': 'ntgdn'
                            }
                        },
                        'props': {
                            'type': 'SvgShapeProperties',
                            'metaData': {
                                'schemaVersion': '1.0',
                                'pageId': 'ntgdn'
                            },
                            'maintainAspectRatio': true
                        },
                        'style': {
                            'type': 'ComponentStyle',
                            'metaData': {
                                'isPreset': false,
                                'schemaVersion': '1.0',
                                'isHidden': false,
                                'pageId': 'ntgdn'
                            },
                            'style': {
                                'properties': {
                                    'alpha-fillcolor': '1',
                                    'alpha-stroke': '1',
                                    'fillcolor': '#000000',
                                    'stroke': '#FFFFFF',
                                    'strokewidth': '2'
                                },
                                'propertiesSource': {
                                    'alpha-fillcolor': 'value',
                                    'alpha-stroke': 'value',
                                    'fillcolor': 'value',
                                    'stroke': 'value',
                                    'strokewidth': 'value'
                                },
                                'groups': {}
                            },
                            'componentClassName': 'wysiwyg.viewer.components.PopupCloseIconButton',
                            'pageId': '',
                            'compId': '',
                            'styleType': 'custom',
                            'skin': 'svgshape.v2.Svg_001419cc721a440abc4ab12ed150b744'
                        },
                        'connections': {
                            'type': 'ConnectionList',
                            'items': [
                                {
                                    'type': 'WixCodeConnectionItem',
                                    'role': 'button2'
                                }
                            ],
                            'metaData': {
                                'pageId': 'ntgdn'
                            }
                        },
                        'mobileStructure': {
                            'layout': {
                                'width': 26,
                                'height': 26,
                                'x': 254,
                                'y': 20,
                                'scale': 1,
                                'rotationInDegrees': 0,
                                'fixedPosition': false
                            },
                            'metaData': {
                                'originalCompId': 'comp-isrejg3w',
                                'author': 'duplicate'
                            }
                        },
                        'activeModes': {}
                    }
                ],
                skin: 'wysiwyg.viewer.skins.stripContainer.DefaultStripContainer',
                layout: {
                    width: 857,
                    height: 480,
                    x: 61,
                    y: 149,
                    scale: 1,
                    rotationInDegrees: 0,
                    fixedPosition: false
                },
                componentType: 'wysiwyg.viewer.components.PopupContainer',
                props: {
                    type: 'PopupContainerProperties',
                    metaData: {schemaVersion: '1.0'},
                    horizontalAlignment: 'center',
                    verticalAlignment: 'center',
                    alignmentType: 'nineGrid',
                    horizontalOffset: 0,
                    verticalOffset: 0,
                    id: 'propItem-im24czk5'
                },
                design: {
                    type: 'MediaContainerDesignData',
                    metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                    background: {
                        type: 'BackgroundMedia',
                        metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                        color: '#FFFFFF',
                        colorOpacity: 1,
                        alignType: 'center',
                        fittingType: 'fill',
                        scrollType: 'none',
                        colorOverlay: '',
                        colorOverlayOpacity: 0
                    },
                    id: 'dataItem-im24czk51'
                },
                style: {
                    type: 'TopLevelStyle',
                    metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                    style: {
                        groups: {},
                        properties: {'alpha-bg': '1', bg: 'rgba(255,255,255,1)'},
                        propertiesSource: {'alpha-bg': 'value', bg: 'value'}
                    },
                    componentClassName: 'wysiwyg.viewer.components.PopupContainer',
                    pageId: '',
                    compId: '',
                    styleType: 'custom',
                    skin: 'wysiwyg.viewer.skins.stripContainer.DefaultStripContainer',
                    id: 'style-im24czk61'
                },
                behaviors: {
                    type: 'ObsoleteBehaviorsList',
                    items: '[{"name":"FadeIn","delay":0.1,"duration":0.75,"action":"screenIn","targetId":"","params":{}},{"name":"FadeOut","delay":0.1,"duration":0.75,"action":"exit","targetId":"","params":{}}]',
                    id: 'behavior-iomlwedk'
                }
            }
        ],

        skin: 'skins.core.InlineSkin',
        layout: {
            width: 980,
            height: 629,
            x: 0,
            y: 0,
            scale: 1,
            rotationInDegrees: 0,
            fixedPosition: false
        },
        componentType: 'mobile.core.components.Page',
        data: {
            type: 'Page',
            metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
            title: 'add_preset_popups_Contact_4',
            hideTitle: true,
            icon: '',
            descriptionSEO: '',
            metaKeywordsSEO: '',
            pageTitleSEO: '',
            pageUriSEO: 'copy-of-contact3',
            hidePage: true,
            underConstruction: false,
            tpaApplicationId: 0,
            pageSecurity: {requireLogin: false, passwordDigest: '', dialogLanguage: ''},
            isPopup: true,
            indexable: false,
            isLandingPage: false,
            pageBackgrounds: {
                desktop: {
                    ref: {
                        type: 'BackgroundMedia',
                        metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                        color: '#63CDFF',
                        colorOpacity: 0.84,
                        alignType: 'center',
                        fittingType: 'fill',
                        scrollType: 'none',
                        colorOverlay: '',
                        colorOverlayOpacity: 0
                    }
                },
                mobile: {
                    custom: true,
                    ref: {
                        type: 'BackgroundMedia',
                        metaData: {isPreset: false, schemaVersion: '1.0', isHidden: false},
                        color: '#63CDFF',
                        colorOpacity: 0.84,
                        alignType: 'center',
                        fittingType: 'fill',
                        scrollType: 'scroll',
                        colorOverlay: '',
                        colorOverlayOpacity: 0
                    },
                    isPreset: true
                }
            },
            ignoreBottomBottomAnchors: true
        },
        props: {
            type: 'PageProperties',
            metaData: {schemaVersion: '1.0'},
            desktop: {popup: {closeOnOverlayClick: true}},
            mobile: {popup: {closeOnOverlayClick: true}},
            id: 'ntgdn'
        },
        style: 'p1',
        tpaComps: []
    },
    preset: {
        rect: {width: 305, height: 202, x: 10, y: 686},
        label: 'add_preset_popups_Contact_4',
        tags: null
    }
}
